import {
  Stack,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { materialBusiness } from "api/bussiness/material/material-bussiness";
import { invalidateMaterialCatalogCache } from "api/cached";
import { MaterialPermission } from "commons/enum/permission";
import { cloneDeep } from "lodash";
import { observer } from "mobx-react-lite";
import { IMaterialProperties } from "mobx-stores/_models/material-inventory/material";
import { useStores } from "mobx-stores/_root-store";
import { useCallback, useEffect } from "react";
import { NumberText } from "share-components/atomics/number-text";
import {
  EditIconButton,
  RemoveIconButton,
} from "share-components/mui-wrap/button/action-button";
import { XTablePagination } from "share-components/mui-wrap/table/x-table-pagination";
export const MaterialTable = observer(() => {
  const queryClient = useQueryClient();
  const {
    deleteConfirmationStore,
    materialStore: { materials, getMaterials, pagination, setProp },
  } = useStores();

  useEffect(() => {
    getMaterials();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onPageChanged = useCallback(
    (_: any, page: number) => {
      pagination.setProp("pageIndex", page - 1);
      getMaterials();
    },
    [getMaterials, pagination],
  );

  const onEditBtnClickHandler = useCallback(
    (item: IMaterialProperties) => {
      setProp("openEdit", true);
      setProp("materialDetail", cloneDeep(item));
    },
    [setProp],
  );

  const onDelete = useCallback(
    async (item: IMaterialProperties) => {
      if (item && item.id) {
        await materialBusiness.delete(item?.id);
        await invalidateMaterialCatalogCache(queryClient);
        getMaterials();
      }
    },
    [getMaterials, queryClient],
  );

  const onDeleteBtnClickHandler = useCallback(
    (item: IMaterialProperties) => {
      setProp("materialDetail", cloneDeep(item));
      deleteConfirmationStore.setProp("open", true);
      deleteConfirmationStore.setDeletionCallback(() => {
        onDelete(item);
      });
    },
    [deleteConfirmationStore, onDelete, setProp],
  );

  return (
    <XTablePagination
      paginationProps={{
        count: pagination.totalPages,
        page: pagination.pageNumber,
        onChange: onPageChanged,
      }}
    >
      <TableHead>
        <TableRow>
          <TableCell style={{ textWrap: 'nowrap' }}>Bộ phận/Khâu SX</TableCell>
          <TableCell>Loại Hàng</TableCell>
          <TableCell>Tên Hàng (Mã Hàng)</TableCell>
          <TableCell>Mã barcode</TableCell>
          <TableCell>Dài (Ngang)</TableCell>
          <TableCell>Rộng (Dọc)</TableCell>
          <TableCell>Cao (Dày)</TableCell>
          <TableCell>Tồn Kho Cho Phép</TableCell>
          <TableCell></TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {materials.map((x, i) => (
          <TableRow data-id={x.id} key={x.id} hover>
            <TableCell>{x.code || ""}</TableCell>
            <TableCell>{x.type || ""}</TableCell>
            <TableCell>{x.name || ""}</TableCell>
            <TableCell>{x.barcode || ""}</TableCell>

            <TableCell>
              <NumberText value={x.specificationSize}></NumberText>
            </TableCell>
            <TableCell>
              <NumberText value={x.specificationLength}></NumberText>
            </TableCell>
            <TableCell>
              <NumberText value={x.specificationThick}></NumberText>
            </TableCell>
            <TableCell>{x.allowedInventory || ""}</TableCell>
            <TableCell width={"20px"}>
              <Stack direction={"row"} spacing={0.5}>
                <EditIconButton
                  accessPermission={[MaterialPermission.Update]}
                  onClick={() => onEditBtnClickHandler(x)}
                ></EditIconButton>

                <RemoveIconButton
                  accessPermission={[MaterialPermission.Delete]}
                  onClick={() => onDeleteBtnClickHandler(x)}
                ></RemoveIconButton>
              </Stack>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </XTablePagination>
  );
});
